import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconEnter: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="enter, return, keyboard, submit, confirm"><path d="M20.25 3.75V10.75V20.25H10.75H3.75L3.75 9.75H9.75V3.75L20.25 3.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M15 9.75V15H10" stroke="currentColor" strokeWidth="1.5"/><path d="M11 12.5L7.5 15L11 17.5V15V12.5Z" fill="currentColor"/></CentralIconBase>;
};

export default IconEnter;
